// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root__VGMTbTqvl2{padding:var(--dixa-size-spacer-300)}.wrapper__l5uytOVc2x{flex-grow:1;min-width:250px}`, "",{"version":3,"sources":["webpack://./src/assets/components/conversation/components/timelineComponent/timelineItem/timelineItemRow/timelineItemRow.module.scss"],"names":[],"mappings":"AAEA,kBACE,mCAAA,CAGF,qBACE,WAAA,CACA,eAAA","sourcesContent":["@import '@dixa/lib-shared-tokens/scss';\n\n.root {\n  padding: var(--dixa-size-spacer-300);\n}\n\n.wrapper {\n  flex-grow: 1;\n  min-width: 250px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `root__VGMTbTqvl2`,
	"wrapper": `wrapper__l5uytOVc2x`
};
export default ___CSS_LOADER_EXPORT___;
